<template lang="pug">
        circle(v-if='sextant.visible' :r="2", :cx="pos.x", :cy="pos.y", fill="none",:stroke="level_color",stroke-width="0.1" )
</template>

<script>
    export default {
        name: "sextant"
        , props: {sextant: Object, pos: Object}
        , computed: {
            level_color() {
                let sextant_colors = ['rgba(41, 128, 215,1.0)', 'rgba(46, 204, 113,1.0)', 'rgba(243, 156, 18,1.0)', 'rgba(231, 76, 60,1.0)'];
                return sextant_colors[this.sextant.level];
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Sextant.vue